// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --awl-primary: #01978d; 
  --text-dark: #1f2937;
  --text-light: #6b7280;
  --bg-main: #f3f4f6; 
  --bg-card: #ffffff;
  --border-color: #e5e7eb;
}

.profile-page-container {
  background-color: var(--bg-main);
  padding-bottom: 1.5rem;
}

.profile-header {
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
}

.back-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-dark);
  cursor: pointer;
  margin-right: 1rem;
}

.profile-header-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-dark);
}

.profile-content {
  padding: 1rem;
}

.profile-hero {
  text-align: center;
  margin-bottom: 1rem;
}

.profile-avatar {
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  background-color: var(--awl-primary);
  color: white;
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  font-weight: 700;
}

.profile-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-dark);
  margin-bottom: 0.25rem;
}

.profile-email {
  font-size: 1rem;
  color: var(--text-light);
  margin-top: 0;
}

.profile-details-card {
  padding: 0.5rem;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem;
  border-bottom: 1px solid var(--border-color);
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-label {
  font-size: 0.875rem;
  color: var(--text-light);
}

.detail-value {
  font-weight: 600;
  color: var(--text-dark);
}`, "",{"version":3,"sources":["webpack://./src/Profile.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[":root {\n  --awl-primary: #01978d; \n  --text-dark: #1f2937;\n  --text-light: #6b7280;\n  --bg-main: #f3f4f6; \n  --bg-card: #ffffff;\n  --border-color: #e5e7eb;\n}\n\n.profile-page-container {\n  background-color: var(--bg-main);\n  padding-bottom: 1.5rem;\n}\n\n.profile-header {\n  display: flex;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  background-color: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.back-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--text-dark);\n  cursor: pointer;\n  margin-right: 1rem;\n}\n\n.profile-header-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-dark);\n}\n\n.profile-content {\n  padding: 1rem;\n}\n\n.profile-hero {\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.profile-avatar {\n  width: 6rem;\n  height: 6rem;\n  border-radius: 50%;\n  background-color: var(--awl-primary);\n  color: white;\n  margin: 0 auto 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 3rem;\n  font-weight: 700;\n}\n\n.profile-name {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-dark);\n  margin-bottom: 0.25rem;\n}\n\n.profile-email {\n  font-size: 1rem;\n  color: var(--text-light);\n  margin-top: 0;\n}\n\n.profile-details-card {\n  padding: 0.5rem;\n}\n\n.detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.25rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.detail-item:last-child {\n  border-bottom: none;\n}\n\n.detail-label {\n  font-size: 0.875rem;\n  color: var(--text-light);\n}\n\n.detail-value {\n  font-weight: 600;\n  color: var(--text-dark);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
